import React from 'react';
import {Cover, Slider, Hero, Carousel } from '../components';

export const Home = () => {
  return (
    <>
      <Cover />
      <Hero />
      <Carousel />
      <Slider />
    </>
  )
}